import {
    FETCH_ROLES_REQUEST,
    FETCH_ROLES_SUCCESS,
    FETCH_ROLES_ERROR,
    SHOW_ROLE_LOADER,
    HIDE_ROLE_LOADER,
    CREATE_ROLE_REQUEST,
    CREATE_ROLE_SUCCESS,
    CREATE_ROLE_ERROR,
    CREATE_ROLE_RESET,
    UPDATE_ROLE_REQUEST,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_ERROR,
    UPDATE_ROLE_RESET,
    FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST,
    FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS,
    FETCH_ALL_RESOURCE_PERMISSIONS_ERROR,
    FETCH_ROLE_MAKERS_REQUEST,
    FETCH_ROLE_MAKERS_SUCCESS,
    FETCH_ROLE_MAKERS_ERROR,
} from './roleManagement.constants';

// Fetch Roles
export const fetchRolesRequest = payload => ({
    type: FETCH_ROLES_REQUEST,
    payload,
});

export const fetchRolesSuccess = payload => ({
    type: FETCH_ROLES_SUCCESS,
    payload,
});

export const fetchRolesError = payload => ({
    type: FETCH_ROLES_ERROR,
    payload,
});

// Create Role
export const createRoleRequest = payload => ({
    type: CREATE_ROLE_REQUEST,
    payload,
});

export const createRoleSuccess = payload => ({
    type: CREATE_ROLE_SUCCESS,
    payload,
});

export const createRoleError = payload => ({
    type: CREATE_ROLE_ERROR,
    payload,
});

export const createRoleReset = payload => ({
    type: CREATE_ROLE_RESET,
});

// Update Role
export const updateRoleRequest = payload => ({
    type: UPDATE_ROLE_REQUEST,
    payload,
});

export const updateRoleSuccess = payload => ({
    type: UPDATE_ROLE_SUCCESS,
    payload,
});

export const updateRoleError = payload => ({
    type: UPDATE_ROLE_ERROR,
    payload,
});

export const updateRoleReset = payload => ({
    type: UPDATE_ROLE_RESET,
});

// Get All Resource Permissions
export const getAllResourcePermissionsRequest = payload => ({
    type: FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST,
    payload,
});

export const getAllResourcePermissionsSuccess = payload => ({
    type: FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS,
    payload,
});

export const getAllResourcePermissionsError = payload => ({
    type: FETCH_ALL_RESOURCE_PERMISSIONS_ERROR,
    payload,
});

// Get All Makers Details
export const getMakersDetailsRequest = payload => ({
    type: FETCH_ROLE_MAKERS_REQUEST,
    payload,
});

export const getMakersDetailsSuccess = payload => ({
    type: FETCH_ROLE_MAKERS_SUCCESS,
    payload,
});

export const getMakersDetailsError = payload => ({
    type: FETCH_ROLE_MAKERS_ERROR,
    payload,
});

// Fetching Loader
export const showLoader = () => ({ type: SHOW_ROLE_LOADER });

export const hideLoader = () => ({ type: HIDE_ROLE_LOADER });
